import { TypographyColor } from 'melp-design/components';
import { ClaimStatus } from './claims.types';

export const COLOR_BY_STATUS: Record<ClaimStatus, TypographyColor> = {
  approved: 'success',
  paid: 'primary',
  rejected: 'error',
  pendingEmployeeAction: 'warning',
  pendingHRAction: 'warning',
};

export const COMPANY_EXPENSE_ID = 'companyExpense';
